import React from 'react'

const SimpleIconCard = ({ cardHeader, cardText, cardIcon }) => {
    return (
        <div className='generic-card px-9 py-12 gap-8 tablet:py-16 break-words'>
            <img src={cardIcon} alt='card-icon' className='h-[50px] w-[50px] tablet:h-[80px] tablet:w-[80px]' />
            <div className='flex flex-col gap-3'>
                <p className='text-fontSize6-bold text-brandPurple tablet:text-fontSize9'>{cardHeader}</p>
                {cardText &&
                    <p className='text-fontSize4 text-brandDarkBlue1 tablet:text-fontSize5'>{cardText}</p>
                }
            </div>
        </div>
    )
}

export default SimpleIconCard